import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Switch } from '@/components/common/switch';

interface ISettingsSwitchProps {
  name: string;
  label: string;
  control: any;
  defaultValue: boolean | undefined;
  labelWidth?: string;
}

export const SettingsSwitch: React.FC<ISettingsSwitchProps> = ({
  name,
  label,
  control,
  defaultValue,
  labelWidth = 'w-full',
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <span className={`flex gap-2 ${labelWidth} text-lg text-gray-600`}>
        <Controller
          render={({ field: { onChange, value } }) => (
            <Switch label={t(label)} isToggled={value} onToggle={onChange} />
          )}
          control={control}
          name={name}
          defaultValue={defaultValue}
        />
      </span>
    </div>
  );
};
